import { getDeclarationsForm } from '../../../selectors/personalAccident/declarations';
import { getDeclarationIsApiPending } from '../../../selectors/personalAccident/declarations';
import { apiTransitionDeclarationsForm } from '../../../actions/personalAccident/declarations';
import { getAccessToken } from '../../../selectors/personalAccident/payments';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/personalAccident/personalDetails';

export const declarationsSubmitService = (store, next, action) => {
    (async () => {
        if (!getDeclarationIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDeclarationsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionDeclarationsForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionDeclarationsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const declarations = getDeclarationsForm(state);
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId.value,
        //declarations
        hasPreviouslyHeldPolicy: declarations.hasPreviouslyHeldPolicy?.value === 'yes',
        previousInsuranceName:
            declarations.hasPreviouslyHeldPolicy?.value === 'yes' ? declarations.previousInsurerName?.value : 'N/A',
        previousInsuranceAddress:
            declarations.hasPreviouslyHeldPolicy?.value === 'yes' ? declarations.hasPreviouslyHeldPolicy?.value : 'N/A',
        previousInsuranceBranch:
            declarations.hasPreviouslyHeldPolicy?.value === 'yes' ? declarations.previousInsurerBranch?.value : 'N/A',
        previousInsurancePolicyNumber:
            declarations.hasPreviouslyHeldPolicy?.value === 'yes' ? declarations.previousInsurerPolicyNo?.value : 'N/A',
        hasAdditionalPolicies: declarations.isAdditionalPolicy?.value === 'yes',
        numberOfAdditionalPolicies:
            declarations.isAdditionalPolicy?.value === 'yes' && declarations.additionalPolicyNumber?.value
                ? declarations.additionalPolicyNumber?.value
                : 0,
        additionalPoliciesDeathBenefitTotal:
            declarations.isAdditionalPolicy?.value === 'yes'
                ? declarations.additionalPolicyTotalDeathBenefit?.value
                : 0,
        hasHadProposalDeclined: declarations.declinedProposal?.value === 'yes',
        hasBeenDeniedRenewal: declarations.refusedRenewal?.value === 'yes',
        hasTerminatedInsuranceBefore: declarations.terminatedInsurance?.value === 'yes',
        terminatedInsuranceDetails:
            declarations.terminatedInsurance?.value === 'yes' && declarations.terminatedInsuranceDetails?.value
                ? declarations.terminatedInsuranceDetails?.value
                : 'N/A',
        hasRequiredPremiumIncrease: declarations.requiredPremiumIncrease?.value === 'yes',
        imposedSpecialConditions: declarations.imposedSpecialConditions?.value === 'yes',
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/declarations';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
